import { Button, HStack, Input } from '@chakra-ui/react'
import React from 'react'

const DiscountCodeInput = () => (
  <HStack spacing={4} my={4}>
    <Input placeholder='Enter discount code' />
    <Button colorScheme='blue'>Apply</Button>
  </HStack>
)

export default DiscountCodeInput
